<div class="order-summary-note">
    <div [innerHTML]="text" ></div>

    <ng-container *ngIf="getInsurerSummaryNote().show">
        <hr>
        {{ getInsurerSummaryNote().note | translate }}
    </ng-container>
</div>